import { SprinklesElement } from "sprinkles-js";

/**
 * This element should wrap around the donate iframe from payrexx
 *
 * See the payrexx docs for more info: https://docs.payrexx.com/developer/guides/embedding/iframe
 */
export default class PayrexxIframeElement extends SprinklesElement {
  static tagName = "payrexx-iframe";
  static refs = ["frame"];
  static events = {
    message: { method: "handlePostMessage", element: window },
    load: { method: "handleLoad", ref: "frame" },
  };

  handleLoad() {
    // We have to send a first message to the iframe, so that it's starts sending things back
    this.refs.frame.contentWindow.postMessage(
      JSON.stringify({ origin: window.location.origin }),
      this.refs.frame.getAttribute("src"),
    );
  }

  handlePostMessage(event) {
    if (typeof event.data !== "string") return;
    const data = this.#parseData(event.data);
    if (data === null || data.payrexx === undefined) return;

    if (data.payrexx.height) {
      // This value will be something like `"1px"`
      this.#updateFrameHeight(data.payrexx.height);
    }

    if (data.payrexx.top) {
      // This value will be something like `"1px"`
      this.#scrollToTop(data.payrexx.top);
    }
  }

  #updateFrameHeight(height) {
    this.refs.frame.setAttribute("height", parseInt(height));
  }

  #scrollToTop(value) {
    const offset = parseInt(value);
    window.scrollTo({
      top: offset + this.refs.frame.offsetTop,
      behavior: "smooth",
    });
  }

  #parseData(data) {
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  }
}
